<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div id="container" class="container" fxLayout="column" fxFill>
  <div id="content_container" class="content_container" fxLayout="row">
    <app-filter-panel [title]="filterTitle" [(isOpen)]="filterOpen" [resetDisabled]="isFilterDefault" (filterReset)="onFilterReset()">
      <p class="filter-section-header" i18n="@@general">General</p>
      <div class="filter-input">
        <mat-form-field id="filter_search_field" appearance="outline">
        <mat-label i18n="@@taskNameOrDescription">Task name or description</mat-label>
        <fa-icon
          id="search_icon"
          matSuffix
          class="icon filter_icon"
          [icon]="faSearch"
          aria-label="user settings button"
        ></fa-icon>
        <input
          id="filter_search"
          type="text"
          matInput
          [(ngModel)]="filter.searchText"
          (keyup)="filterInputFieldChanged()"
        />
        </mat-form-field>
      </div>

      <!--Workflow + Version Filters (side by side)-->
      <div id="workflow_version_container" class="filter-input">
        <!-- Workflow Filter -->
        <app-grouped-chips-autocomplete
          id="workflow_filter"
          title="Workflow"
          i18n-title="label for workflow dropdown field@@workflowDropDown"
          inputPlaceholder="Search workflow name"
          i18n-inputPlaceholder="@@searchWorkflowName"
          [groups]="workflowFilterGroups"
          [(ngModel)]="workflowFilterValue"
          [singleSelect]="true"
          [multiSelect]="false"
          [multiGroupSelect]="false"
          [subscriptSizing]="'dynamic'"
          (ngModelChange)="onWorkflowFilterChange($event)">
        </app-grouped-chips-autocomplete>
        
        <!-- Version Filter -->
        <app-grouped-chips-autocomplete
          id="version_filter"
          title="Version"
          i18n-title="label for version dropdown field@@versionDropDown"
          inputPlaceholder="All"
          i18n-inputPlaceholder="@@all"
          [groups]="versionFilterGroups"
          [(ngModel)]="versionFilterValue"
          [singleSelect]="true"
          [multiSelect]="false"
          [multiGroupSelect]="false"
          [subscriptSizing]="'dynamic'"
          [optionTemplate]="versionOptionTpl"
          (ngModelChange)="onVersionFilterChange($event)">
        </app-grouped-chips-autocomplete>

        <ng-template #versionOptionTpl let-item let-group="group">
          <div class="version-option" [class.version-deleted]="item.disabled">
            <span class="version-name" #versionText [matTooltip]="item.displayName || item.name" [matTooltipDisabled]="!versionText || versionText.scrollWidth <= versionText.clientWidth">{{ item.displayName || item.name }}</span>
            <span class="version-date" *ngIf="versionCreatedAtMap[item.id]">{{ versionCreatedAtMap[item.id] }}</span>
          </div>
        </ng-template>
      </div>

      <app-date-range-picker
        class="filter-input filter-date-range"
        [collapsible]="true"
        [separateStartEnd]="true"
        [withTime]="true"
        [layoutDirection]="LayoutDirection.vertical"
        [dateFilterValue]="dateFilterValue"
        (dateFilterChange)="onDateFilterChange($event)"
      ></app-date-range-picker>

      <!--Status------------------------------------------------------------------------------->
      <p class="filter-section-header" i18n="label for task status filter@@taskStatusFilter">Task status</p>
      <div id="status_field" class="filter-toggle">
        <mat-button-toggle-group
          id="status_toggle"
          name="statusToggle"
          [(ngModel)]="filter.status"
          (change)="searchTask()"
          multiple
          hideMultipleSelectionIndicator
        >
          <mat-button-toggle id="status_new" value="new" i18n="@@statusNew">Open</mat-button-toggle>
          <mat-button-toggle id="status_in_progress" value="in-progress" i18n="@@statusInProgress"
            >In progress</mat-button-toggle
          >
          <mat-button-toggle id="status_finished" value="finished" i18n="@@statusFinished"
            >Finished</mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>
      <!--Assignment status-------------------------------------------------------------------->
      <p class="filter-section-header" i18n="label for assignement-status dropdown field@@assignmentStatus">Employee</p>
      <div id="assignment_status_field" class="filter-toggle">
        <mat-button-toggle-group
          id="assignment_status_toggle"
          name="assignmentStatusToggle"
          [(ngModel)]="filter.assignmentStatus"
          (change)="searchTask()"
          multiple
          hideMultipleSelectionIndicator
        >
          <mat-button-toggle
            id="assignment_unclaimed"
            value="unclaimed"
            i18n="@@assignmentUnclaimed"
            >Unclaimed</mat-button-toggle
          >
          <mat-button-toggle id="assignment_claimed" value="claimed" i18n="@@assignmentClaimed"
            >Claimed</mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>
      <!-- filter for employees and employee groups -->
      <app-grouped-chips-autocomplete
        id="employee_filter"
        class="filter-input"
        title="Employee or employee group"
        i18n-title="label for employee and employee group filter@@employeeAndGroupFilter"
        inputPlaceholder="Search employees or groups..."
        i18n-inputPlaceholder="placeholder for employee filter search@@employeeFilterSearchPlaceholder"
        [groups]="employeeFilterGroups"
        [(ngModel)]="employeeFilterValue"
        [multiSelect]="true"
        [multiGroupSelect]="true"
        (ngModelChange)="onEmployeeFilterChange($event)"
      ></app-grouped-chips-autocomplete>
      <mat-checkbox
        id="include_group_members_checkbox"
        class="filter-checkbox filter-group-members-checkbox"
        color="primary"
        [disabled]="filter.employeeGroups.length === 0"
        [(ngModel)]="filter.includeGroupMembers"
        (change)="searchTask()"
        ><mat-label i18n="label for including group members in task filter@@includeGroupMembersFilter"
          >Include tasks assigned to employees in groups</mat-label
        ></mat-checkbox
      >

      <p class="filter-section-header" i18n="@@references">References</p>
      <!--Reference Type----------------------------------------------------------------------->
      <div class="filter-input">
        <mat-form-field id="reference_type_field" appearance="outline">
        <mat-label i18n="label for reference type field@@referenceType">Reference type</mat-label>
        <mat-select
          id="reference_dropdown"
          [(value)]="filter.refType"
          (selectionChange)="searchTask()"
          placeholder="Search reference type"
          i18n-placeholder="placeholder for reference type dropdown@@referenceTypePlaceholder"
        >
          <mat-option
            class="reference-option"
            i18n="label for clear selection button@@clearSelectionBtn"
            >Clear selection</mat-option
          >
          <mat-option
            class="reference-option"
            *ngFor="let reference of references"
            [value]="reference"
          >
            {{ reference }}
          </mat-option>
        </mat-select>
        </mat-form-field>
      </div>
      <!--Reference Value---------------------------------------------------------------------->
      <div class="filter-input">
        <mat-form-field id="reference_value_field" appearance="outline">
        <mat-label i18n="label for reference value field@@referenceValue"
          >Reference value</mat-label
        >
        <input
          id="filter_reference_value"
          type="text"
          matInput
          [(ngModel)]="filter.refValue"
          (keyup)="filterInputFieldChanged()"
        />
        </mat-form-field>
      </div>
      <mat-checkbox
        id="empty_reference_values_checkbox"
        class="filter-checkbox"
        color="primary"
        [disabled]="!filter.refType"
        [(ngModel)]="showEmptyReferenceValues"
        (change)="searchTask()"
        ><mat-label i18n="label for empty reference value filter@@emptyReferenceFilter"
          >Include empty reference values in results</mat-label
        ></mat-checkbox
      >
    </app-filter-panel>
    <div fxLayout="row" fxFlex="calc(100%-373px)">
      <as-split direction="horizontal">
        <as-split-area [size]="40" [minSize]="30">
          <div
            id="new_list_container"
            class="new_list_container mat-elevation-z0 full-height"
            fxLayout="column"
          >
            <!-- header -->
            <div
              id="new_header_container"
              class="new_header_container"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              <span id="TaskTitle" class="subtitle text-uppercase" i18n="@@tasks">tasks</span>
              <div class="expand"></div>
              <button
                id="add_new_task_button"
                [disabled]="!enableTaskAddButton"
                mat-icon-button
                class="add-button"
                color="secondary"
                matTooltip="Add new task"
                i18n-matTooltip="@@addNewTask"
                aria-label="task-manager"
                routerLink="task-manager"
                routerLinkActive="active_item"
              >
                <fa-icon class="icon" [icon]="faPlus" aria-label="task manager button"></fa-icon>
              </button>
            </div>

            <mat-divider></mat-divider>

            <cdk-virtual-scroll-viewport
              id="task_item_container"
              itemSize="51"
              class="new_list_item_container full-height"
              (scrolledIndexChange)="scrollOffset($event)"
            >
              <div
                id="new_list_item"
                class="new_list_item task-item"
                *cdkVirtualFor="let task of displayedTasks; let i = index; trackBy: trackByIdx"
                [routerLink]="task.taskId"
                queryParamsHandling="preserve"
                routerLinkActive="active_item"
              >
                <div fxLayout="row" fxLayoutAlign="start center">
                  <fa-icon
                    id="task_status_icon"
                    [ngStyle]="{ color: task.status == TaskStatus.NEW ? '#3498DB' : '#267963' }"
                    class="icon task_status_icon"
                    [icon]="task.status | taskStatusIcon"
                    aria-label="user settings button"
                  ></fa-icon>
                  <span>{{ task.name }}</span>
                  <span class="expand"></span>

                  <!-- Assignment icon currently twice, because user tasks don't have a claim menu -->
                  <div
                    *ngIf="
                      task.groupedTask;
                      then employeegroupAssignmentIcon;
                      else employeeAssignmentIcon
                    "
                  ></div>
                  <ng-template #employeeAssignmentIcon>
                    <div *ngIf="employeeExists(task.assignedTo[0]); else invalidUser">
                      <div *ngIf="isTaskClaimed(task); else unclaimedUser">
                        <div
                          *ngIf="
                            getEmployeeShort(task.claimedBy) as employeeShort;
                            else noEmployeeShort
                          "
                        >
                          <span class="task_claimed_initial">{{ employeeShort }}</span>
                        </div>

                        <ng-template #noEmployeeShort>
                          <div class="task_claimed_icon">
                            <fa-icon id="task_claimed_icon" [icon]="faUser"></fa-icon>
                          </div>
                        </ng-template>
                      </div>

                      <ng-template #unclaimedUser>
                        <div class="task_assignment_icon">
                          <fa-icon [icon]="faUser"></fa-icon>
                        </div>
                      </ng-template>
                    </div>

                    <ng-template #invalidUser>
                      <div class="task_assignment_icon error_icon">
                        <fa-icon id="missingEmployeeIcon" [icon]="faUserSlash"></fa-icon>
                      </div>
                    </ng-template>
                  </ng-template>

                  <ng-template #employeegroupAssignmentIcon>
                    <div
                      *ngIf="
                        employeeGroupsExist(task.assignedTo) as existCount;
                        else invalidUsergroup
                      "
                      [matMenuTriggerFor]="claimMenu"
                    >
                      <div *ngIf="isTaskClaimed(task); else unclaimedUsergroup">
                        <div
                          *ngIf="
                            getEmployeeShort(task.claimedBy) as employeeShort;
                            else noEmployeegroupShort
                          "
                        >
                          <span
                            id="grouped_task_claimed_initial"
                            class="task_claimed_initial"
                            [ngClass]="{
                              warn_icon: !employeeHasGroups(task.claimedBy, task.assignedTo)
                            }"
                            >{{ employeeShort }}</span
                          >
                        </div>

                        <ng-template #noEmployeegroupShort>
                          <div
                            class="task_claimed_icon"
                            [ngClass]="{
                              warn_icon:
                                !employeeExists(task.claimedBy) ||
                                !employeeHasGroups(task.claimedBy, task.assignedTo)
                            }"
                          >
                            <fa-icon id="grouped_task_claimed_icon" [icon]="faUser"></fa-icon>
                          </div>
                        </ng-template>
                      </div>

                      <ng-template #unclaimedUsergroup>
                        <div
                          id="grouped_task_assignment_icon"
                          class="task_assignment_icon"
                          [ngClass]="{ warn_icon: existCount < task.assignedTo.length }"
                        >
                          <fa-icon [icon]="faUsers"></fa-icon>
                        </div>
                      </ng-template>
                    </div>

                    <ng-template #invalidUsergroup>
                      <div class="task_assignment_icon error_icon">
                        <fa-icon id="missingGroupIcon" [icon]="faUsersSlash"></fa-icon>
                      </div>
                    </ng-template>
                  </ng-template>

                  <mat-menu #claimMenu="matMenu" xPosition="before" class="custom-claim-menu">
                    <ng-template matMenuContent>
                      <app-claim-menu [task]="task"></app-claim-menu>
                    </ng-template>
                  </mat-menu>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </as-split-area>
        <as-split-area [size]="60" [minSize]="30">
          <div id="task_details" class="detail">
            <router-outlet></router-outlet>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </div>
</div>
